import { Link, useLocation } from 'react-router-dom';

interface CategoryTab {
  slug: string;
  name: string;
  icon: string;
}

interface CategoryTabsProps {
  categories: CategoryTab[];
  activeSlug: string;
  basePath?: string;
}

export default function CategoryTabs({ categories, activeSlug, basePath = '/category' }: CategoryTabsProps) {
  return (
    <nav aria-label="分类导航" className="flex flex-wrap items-center gap-2 px-1 py-1 bg-background-100 rounded-full">
      <Link
        to="/"
        className={`px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
          !activeSlug
            ? 'bg-primary-500 text-white'
            : 'text-foreground-600 hover:text-primary-500 hover:bg-background-200/70'
        }`}
      >
        全部
      </Link>
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`${basePath}/${cat.slug}`}
          className={`flex items-center gap-1.5 px-5 py-2 rounded-full text-sm font-medium transition-all duration-300 whitespace-nowrap ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-white'
              : 'text-foreground-600 hover:text-primary-500 hover:bg-background-200/70'
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.name}
        </Link>
      ))}
    </nav>
  );
}